<template>
  <div class="data-table-histogram">
    <div class="d-print-none col-12" v-if="enableSearch">
      <input type="search" v-model="currentSearch" @input="search" placeholder="filtern">
    </div>
    <div class="col-12 table-responsive">
      <table class="table table-fixed mb-0">
        <thead>
        <tr>
          <td v-if="showRowNumbers" class="histogram-row-number">&nbsp;</td>
          <template :key="index" v-for="(column, index) in columns">
            <th
              @click="sort(column.field)"
              :class="{
                'histogram-key': index === 0,
                'histogram-value text-end pe-3': index !== 0,
              }"
            >
              {{ column.label }}
            </th>
          </template>
        </tr>
        </thead>
        <tbody>
        <template v-if="compareTable">
          <tr class="separator">
            <td>&nbsp;</td>
            <template :key="index" v-for="(column, index) in dataColumns">
              <td>
                <div class="d-flex flex-column text-end pe-3">
                            <span>
                                {{
                                calcDiffPercentage(tableData[column.field].total, tableData[column.field].compareTotal)
                              }}
                              <Icon :icon="'fa-pro-solid:'+tableData[column.field].total > tableData[column.field].compareTotal ? 'arrow-up' : 'arrow-down'" />
                            </span>
                  <span class="vs">{{
                      tableData[column.field].total.toLocaleString()
                    }} vs. {{ tableData[column.field].compareTotal.toLocaleString() }}</span>
                </div>
              </td>
            </template>
          </tr>
          <template :key="index" v-for="(row, index) in parsedRows">
            <tr class="header" v-if="extraHeader">
              <td colspan="3">{{ row.key }}</td>
            </tr>
            <tr>
              <td>
                <template v-if="extraHeader">{{ range.from }} - {{ range.to }}</template>
                <template v-else>{{ row.key }}</template>
              </td>
              <template :key="index" v-for="(column, index) in dataColumns">
                <td class="text-end pe-3">
                  {{ row.data?.[column.field]?.toLocaleString() }}
                  <span class="detail">
                                    ({{ formatPercentage(row.data?.[column.field] / tableData[column.field].total) }})
                            </span>
                </td>
              </template>
            </tr>
            <tr>
              <td>
                <template v-if="extraHeader">{{ compareRange.from }} - {{ compareRange.to }}</template>
                <template v-else>{{ row.compareKey }}</template>
              </td>
              <template :key="index" v-for="(column, index) in dataColumns">
                <td class="text-end pe-3">
                  {{ (row.compareData?.[column.field] ?? 0).toLocaleString() }}
                  <span class="detail">
                                ({{
                      formatPercentage(row.compareData?.[column.field] / tableData[column.field].compareTotal)
                    }})
                            </span>
                </td>
              </template>
            </tr>
            <tr class="separator">
              <td>
                <b>Änderung</b>
              </td>
              <template :key="index" v-for="(column, index) in dataColumns">
                <td class="text-end pe-3">
                  <b>{{
                      calcDiffPercentage(row.data?.[column.field], row.compareData?.[column.field])
                    }}</b>
                  <span class="detail">
                            </span>
                </td>
              </template>
            </tr>
          </template>

        </template>
        <template v-else>
          <tr class="separator">
            <td v-if="showRowNumbers" class="histogram-row-number">&nbsp;</td>
            <td class="histogram-key">Gesamt</td>
            <template :key="index" v-for="(column, index) in dataColumns">
              <td class="histogram-value pe-3">
                <div class="d-flex flex-column text-end">
                  {{ tableData[column.field]?.total?.toLocaleString() }}
                </div>
              </td>
            </template>
          </tr>
          <tr :key="index" v-for="(row, index) in sortedRows">
            <td class="text-end histogram-row-number" v-if="showRowNumbers">{{ index + 1 }}.</td>
            <td class="histogram-key">{{ row.key }}</td>
            <template :key="index" v-for="(column, index) in dataColumns">
              <td class="histogram-value text-end pe-3">{{ row.data?.[column.field]?.toLocaleString() }}</td>
            </template>
          </tr>
        </template>
        </tbody>
      </table>
    </div>

    <div class="col-12 col-lg-2" v-if="enableSize">
      <select v-model="pageSize" class="form-control">
        <option :key="index" v-for="(size, index) in availableSizes" :value="size">{{ size }}</option>
      </select>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import Fuse from 'fuse.js';

export default {
  props: {
    columns: Array,
    tableData: Object,
    compareTable: Boolean,
    extraHeader: {
      type: Boolean,
      default: true,
    },
    enableSort: {
      type: Boolean,
      default: true,
    },
    enableSearch: {
      type: Boolean,
      default: true,
    },
    enableSize: {
      type: Boolean,
      default: true,
    },
    showRowNumbers: {
      type: Boolean,
      default: false,
    },
    rangeFrom: {
      type: [Number, String, Date],
      default: null,
    },
    rangeTo: {
      type: [Number, String, Date],
      default: null,
    },
    compareRangeFrom: {
      type: [Number, String, Date],
      default: null,
    },
    compareRangeTo: {
      type: [Number, String, Date],
      default: null,
    },
    initialPageSize: {
      type: Number,
      default: 20,
    },
  },
  data() {
    return {
      // currentSort: this.columns[1].field,
      currentSort: this.initialSort,
      sortedRows: this.tableData.rows.map(a => a),
      currentSearch: null,
      currentSortDir: 'desc',
      pageSizeLocal: this.initialPageSize,
      // currentPage: 1,
      availableSizes: [20, 50, 100, 500, 1000, 5000, 10000],
      dataColumns: this.columns.slice(1),
    }
  },
  mounted() {

  },
  created() {
  },
  watch: {
    'tableData': function (newVal) {
      this.sortedRows = newVal.rows.map(a => a);
    }
  },
  methods: {
    search() {
      const options = {
        keys: [
          "key",
        ],
        threshold: 0.3,
        shouldSort: false,
      };
      const fuse = new Fuse(this.tableData.rows, options);
      const filtered = fuse.search(this.currentSearch);
      const flatten = [];
      filtered.forEach((filteredEntry) => {
        flatten.push(filteredEntry.item);
      });
      if (this.currentSearch.length > 0) {
        this.sortedRows = flatten;
      } else {
        this.sortedRows = this.tableData.rows.map(a => a);
      }
    },
    sort(s) {
      if (!this.enabledSort) {
        return;
      }
      //if s == current sort, reverse
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
    },
    calcDiffPercentage(valueTo, valueFrom) {
      // console.log(`${valueFrom} => ${valueTo}`)
      if (!valueFrom) {
        return valueTo ? '+ ∞' : '± 0';
      }
      if (!valueTo) {
        return valueFrom ? '- ∞' : '± 0';
      }
      const value = (valueTo - valueFrom) / valueFrom;
      return this.formatPercentage(value, true);
    },
    formatPercentage(value, forceSign) {
      if (!value) {
        value = 0;
      }
      let string = (value * 100).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + ' %';
      if (forceSign && value > 0) {
        string = '+' + string;
      }
      return string;
    },
    sortRows() {
      return this.sortedRows.sort((a, b) => {
        let modifier = 1;
        if (this.currentSortDir === 'desc') {
          modifier = -1;
        }
        if (a[this.currentSort] < b[this.currentSort] || a.data?.[this.currentSort] < b.data?.[this.currentSort]) {
          return -1 * modifier;
        }
        if (a[this.currentSort] > b[this.currentSort] || a.data?.[this.currentSort] > b.data?.[this.currentSort]) {
          return modifier;
        }
        return 0;
      // }).filter((row, index) => {
      //   let start = (this.currentPage - 1) * this.pageSize;
      //   let end = this.currentPage * this.pageSize;
      //   if (index >= start && index < end) return true;
      });
    }
  },
  computed: {
    compareRange() {
      if (this.compareRangeFrom && this.compareRangeTo) {
        return {
          from: dayjs(this.compareRangeFrom).format('DD.MM.YYYY'),
          to: dayjs(this.compareRangeTo).format('DD.MM.YYYY')
        }
      }
      return false;
    },
    range() {
      const from = this.rangeFrom || this.tableData?.from
      const to = this.rangeTo || this.tableData?.to
      if (!from || !to) {
        return {from: '-', to: '-'}
      }
      return {
        from: dayjs(from).format('DD.MM.YYYY'),
        to: dayjs(to).format('DD.MM.YYYY')
      }
    },
    parsedRows() {
      if (!this.enableSort) {
        return this.sortedRows;
      }
      return this.sortRows()
    },
    pageSize: {
      get() {
        return this.pageSizeLocal;
      },
      set(value) {
        this.pageSizeLocal = value;
      }
    }
  },

}
</script>

<style lang="scss">
.data-table-histogram {
  min-width: 0;
  max-width: 100%;
}

.table-fixed {
  table-layout: fixed;
  width: 100%;
}

.histogram-row-number {
  width: 2.5rem;
}

.histogram-key {
  max-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.histogram-value {
  width: 6.5rem;
  white-space: nowrap;
}

.vs,
.detail {
  color: var(--bs-secondary);
  font-size: 0.85em;
}

.detail {
  display: inline-block;
  width: 5em;
  white-space: nowrap;
}
</style>
